import { ProviderFeatures } from './provider-features';

export const chargebeeProviderFeatures: ProviderFeatures = {
  actions: {
    cancel: {
      enabled: true,
      schedules: {
        immediate: true,
        'end-of-period': true,
      },
      unpauseOnCancel: false,
    },
    pause: {
      enabled: true,
      extendPeriodEnd: true,
      startDates: {
        'period-end': true,
        immediate: true,
      },
      durations: {
        period: true,
        date: true,
      },
    },
    changePrice: {
      enabled: true,
      schedules: {
        immediate: true,
        'end-of-period': true,
      },
      prorate: true,
    },
    applyCoupon: {
      enabled: true,
    },
    extendTrial: {
      enabled: true,
    },
  },
  controllers: {
    coupons: {
      enabled: true,
      create: true,
      import: true,
    },
    customers: {
      findByEmail: true,
    },
  },
  features: {
    metricsDashboard: true,
    customerProfile: true,
  },
};
